import moment from 'moment'

const moment24HourParser = ['HH:mm']

export function format24HourTime(time: string, format: string) {
  return moment(time, moment24HourParser).format(format)
}
